import React from 'react';
import './Help.css';

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="help-section">
      <h2 className="help-section-title">{title}</h2>
      <div className="help-section-body">{children}</div>
    </div>
  );
}

function Bullet({ children }: { children: React.ReactNode }) {
  return (
    <div className="help-bullet-row">
      <span className="help-bullet">•</span>
      <span className="help-bullet-text">{children}</span>
    </div>
  );
}

export default function Help() {

  return (
    <div className="help-container">
      <div className="help-content">
        <h1 className="help-title">Help & How‑To</h1>

        <Section title="Getting Started">
          <Bullet>Use the navigation menu to switch between Overview, Cars, Customers, Rentals, Services, and Help.</Bullet>
          <Bullet>The UI is responsive — content centers with a max width on large screens.</Bullet>
          <Bullet>Icons are provided by React Icons with fallbacks for web.</Bullet>
        </Section>

        <Section title="Cars">
          <Bullet>Click "Add New Car" to create a car. License plate is the main identifier.</Bullet>
          <Bullet>Enter the odometer in kilometers. Vehicle fitness expiration can be added.</Bullet>
          <Bullet>Search by plate, make, model, VIN, or year using the search bar.</Bullet>
          <Bullet>A red "service due" badge appears when the car has passed its next service km.</Bullet>
        </Section>

        <Section title="Rentals">
          <Bullet>Create a new rental from the Rentals page.</Bullet>
          <Bullet>Past dates are allowed. End Date is optional for open‑ended rentals.</Bullet>
          <Bullet>On a rental without an end date, use "Mark Returned Today" in the detail view.</Bullet>
        </Section>

        <Section title="Services">
          <Bullet>Log services using the odometer (km). The app suggests the next 5,000 km interval.</Bullet>
          <Bullet>"Next Service at (km)" can be edited if needed. Date is optional.</Bullet>
          <Bullet>Service list shows both the odometer and next service target when available.</Bullet>
        </Section>

        <Section title="Search">
          <Bullet>Each list has a search bar. Type to filter results live.</Bullet>
          <Bullet>Cars: plate, make, model, VIN, year. Customers: name, contact, license.</Bullet>
          <Bullet>Rentals: plate, car, customer, start/end dates. Services: description, plate, car, km, date.</Bullet>
        </Section>

        <Section title="Multi-User Features">
          <Bullet>Each organization has its own data. Users can only see their organization's cars, customers, rentals, and services.</Bullet>
          <Bullet>Admins can manage users and send invitations. Members can use all app features except user management.</Bullet>
          <Bullet>All user actions are logged in the audit collection for compliance and debugging.</Bullet>
        </Section>

        <Section title="Troubleshooting">
          <Bullet>If you see permission errors, ensure you're signed in and your organization is set up correctly.</Bullet>
          <Bullet>If date inputs look too wide, ensure you haven't overridden input styles that remove box‑sizing or max‑width.</Bullet>
          <Bullet>If icons are missing, verify your connection and that React Icons is loaded properly.</Bullet>
        </Section>

        <Section title="Links">
          <Bullet>
            <a href="https://reactrouter.com/" target="_blank" rel="noopener noreferrer" className="help-link">
              React Router docs
            </a>
          </Bullet>
          <Bullet>
            <a href="https://firebase.google.com/docs/firestore" target="_blank" rel="noopener noreferrer" className="help-link">
              Firestore docs
            </a>
          </Bullet>
          <Bullet>
            <a href="https://vitejs.dev/" target="_blank" rel="noopener noreferrer" className="help-link">
              Vite docs
            </a>
          </Bullet>
        </Section>
      </div>
    </div>
  );
}

